import React, { Fragment, useEffect, useState } from "react";
import WhatIsChildCreditActivityMonitoring from "./Faqs/WhatIsChildCreditActivityMonitoring";
import WhatIsCreditActivity from "./Faqs/WhatIsCreditActivity";
import WhatAreKeyTermsDefined from "./Faqs/WhatAreKeyTermsDefined";
import CanIGetACreditActivityAlert from "./Faqs/CanIGetACreditActivityAlert";
import HowDoIKnow from "./Faqs/HowDoIKnow";
import WhereCanIFind from "./Faqs/WhereCanIFind";
import HowFreezeTheirCredit from "./Faqs/HowFreezeTheirCredit";
import ConsumerFreezeAPermanentOption from "./Faqs/ConsumerFreezeAPermanentOption";
import HowDoIFreezeMinor from "./Faqs/HowDoIFreezeMinor";
import Accordion from "./Faqs/Accordion";

const Ccamfaq = (props: any) => {
    const [activeIndex, setActiveIndex] = useState(100);

    const faqDescription = (i: number) => {
        switch (i) {
            case 1:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <WhatIsChildCreditActivityMonitoring />
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <WhatIsCreditActivity />
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <WhatAreKeyTermsDefined />
                            </div>
                        </div>
                    </div>
                );
            case 5:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <CanIGetACreditActivityAlert />
                            </div>
                        </div>
                    </div>
                );
            case 6:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <HowDoIKnow />
                            </div>
                        </div>
                    </div>
                );
            case 7:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <WhereCanIFind />
                            </div>
                        </div>
                    </div>
                );
            case 8:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <HowDoIFreezeMinor />
                            </div>
                        </div>
                    </div>
                );
            case 9:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <HowFreezeTheirCredit />
                            </div>
                        </div>
                    </div>
                );
            case 10:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <ConsumerFreezeAPermanentOption />
                            </div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    const freezeFaqContent = [
        {
            id: 8,
            name: "How do I freeze my minor child’s/dependent’s credit report?",
            content: faqDescription(8),
        },
        {
            id: 9,
            name: "How does my 16-or-17-year-old freeze their credit report?",
            content: faqDescription(9),
        },
        {
            id: 10,
            name: "Is a Protected Consumer Freeze a permanent option?",
            content: faqDescription(10),
        },
    ];

    const faqContent = [
        {
            id: 1,
            name: "What is the value of the Child Credit Activity Monitoring to me as a parent/guardian?",
            content: faqDescription(1),
        },
        {
            id: 2,
            name: "What is credit activity?",
            content: faqDescription(2),
        },
        {
            id: 3,
            name: "What are some key terms defined?",
            content: faqDescription(3),
        },
        {
            id: 5,
            name: "Can I get a credit activity alert from Child Credit Activity monitoring if I have a freeze on my child’s/dependent’s TransUnion credit file?",
            content: faqDescription(5),
        },
        {
            id: 6,
            name: "How do I know if my child's/dependent’s identity has been stolen?",
            content: faqDescription(6),
        },
        {
            id: 7,
            name: "Where can I find more information on Child ID Theft?",
            content: faqDescription(7),
        },
    ];

    return (
        <React.Fragment>
            {props.activityDetected && (
                <div className={`box`} id="freeze-FAQ">
                    <h2 className="box-title">Minor/Child Freeze</h2>
                    <Accordion
                        headers={freezeFaqContent.map((v: any, i: number) => (
                            <Fragment key={`${v.id}-${i}`}>{v.name}</Fragment>
                        ))}
                        content={freezeFaqContent.map((v: any, i: number) => (
                            <Fragment key={v.id}>{v.content}</Fragment>
                        ))}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                    />
                </div>
            )}

            <div className={`box`}>
                <Accordion
                    headers={faqContent.map((v: any, i: number) => (
                        <Fragment key={`${v.id}-${i}`}>{v.name}</Fragment>
                    ))}
                    content={faqContent.map((v: any, i: number) => (
                        <Fragment key={v.id}>{v.content}</Fragment>
                    ))}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                />
            </div>
        </React.Fragment>
    );
};

export default Ccamfaq;
